export const SET_ALL_DEVICES = 'setAllDevices'
export const SET_CURRENT_DEVICE = 'setCurrentDevice'
export const SET_VIEW_SIZE = 'setViewSize'
export const SET_VIEW_SIZE_HEIGHT = 'setViewSizeHeight'
export const SET_CANVAS_SIZE = 'setCanvasSize'
export const SET_CANVAS_OFFSET = 'setCanvasOffset'
export const SET_CANVAS_SCROLL = 'setCanvasScroll'
export const SET_CANVAS_MOUSE_POSITION = 'set-canvas-mouse-position'
export const SET_BUILDER_MOUSE_POSITION = 'set-builder-mouse-position'
